import { Injectable }  from '@angular/core';
import { TranslateService }    from '@ngx-translate/core';
import { NgbModal }            from '@ng-bootstrap/ng-bootstrap';

import { API }              from '../api/api.constant';
import { ApiService }       from '../api/api.service';
import { ConfirmService }   from '../messages/confirm/confirm.service';
import { SessionService }   from '../sessions/session.service';
import { VehicleModel }     from './models/vehicle';

import { AddVehicleFromBranchComponent } from './vehicle.add-from-branch.component';

import { VehicleBranchHistoryComponent }  from './vehicle.branch-history.component';
import { VehicleFollowUpNotesComponent }  from './vehicle.follow-up-notes.component';
import { VehicleFormSettingsComponent }   from './vehicle.form-settings.component';

@Injectable({ providedIn: 'root' })
export class VehicleService {
  constructor (
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private modalService    : NgbModal,
    private sessionService  : SessionService,
    private translateService: TranslateService
  ) {}

  calculatePriceExcludingTax ( costIncludingTax : any ) : number {


    const taxRate = new BigDecimal( this.sessionService.company().purchases_tax_rate.toString() ).setScale(2, BigDecimal.ROUND_HALF_UP).movePointLeft(2);

    costIncludingTax = new BigDecimal( costIncludingTax.toString() ).setScale(4, BigDecimal.prototype.ROUND_HALF_UP);

    const cost = costIncludingTax.divide(BigDecimal.ONE.add(taxRate)).setScale(4, BigDecimal.prototype.ROUND_HALF_UP);

    return parseFloat(cost);


  }

  calculatePriceIncludingTax ( cost : any ) : number {


    const taxRate = new BigDecimal( this.sessionService.company().purchases_tax_rate.toString() ).setScale(2, BigDecimal.ROUND_HALF_UP).movePointLeft(2);

    cost = new BigDecimal( cost.toString() ).setScale(2, BigDecimal.prototype.ROUND_HALF_UP);

    const tax = taxRate.multiply(cost).setScale(2, BigDecimal.prototype.ROUND_HALF_UP);

    return parseFloat(cost.add(tax).toString());


  }

  checkVinUniqueness ( vin : string ) : Promise<boolean> {


    return this.apiService.post('/vehicle/verify_vin_uniqueness', { vin });


  }

  copyFromBranch ( vehicle : VehicleModel, customer_id : string ) : Promise<VehicleModel> {


    return this.apiService.get('/vehicles/copy_from_branch', [ vehicle.id, customer_id ]);


  }

  createVehicleFromOtherBranch ( customer_id : string ) : Promise<any> {
    const modal = this.modalService.open(AddVehicleFromBranchComponent, {
      keyboard   : false,
      windowClass: 'x-lg-modal'
    });

    modal.componentInstance.customer_id = customer_id;

    return modal.result;
  }

  getBranchVehicles ( filters : any ) : Promise<Array<VehicleModel>> {
    return this.apiService.post('/vehicles/list_vehicles_for_customer_from_head_office', filters);
  }

  getFormSettings ( vehicle : VehicleModel ) : Promise<any> {
    const modal = this.modalService.open(VehicleFormSettingsComponent, { windowClass: 'md-modal' });
    modal.componentInstance.vehicle = vehicle;
    return modal.result;
  }

  isMusicalInstrument ( vehicle : VehicleModel ) : boolean {


    return vehicle.vehicle_group === 'MUSIC';


  }

  isUnit ( vehicle : VehicleModel ) : boolean {


    return !!vehicle.date_acquired;


  }

  isLinkedToHeadOffice ( vehicle : VehicleModel ) : boolean {


    return !!vehicle.branch_link;


  }

  printVehicleForm ( vehicle : VehicleModel ) : void {
    this.getFormSettings(vehicle)
    .then(settings => this.apiService.get('/vehicle_form_serial_numbers/check_if_exists', [
      vehicle.id,
      settings.form_code
    ])
    .then(( serialNumber = {} ) => {
      if (serialNumber && serialNumber.id) {
        this.confirmService.generic(this.translateService.instant('JS_SPACE.MESSAGES.FORM_ALREADY_PRINTED'))
        .then(() => window.open(`${ API.url }/reports/jasper_vehicle_forms/${ vehicle.id }/${ settings.form_code }.pdf`, '_blank'));
      }
      else {
        this.apiService.post('/vehicle_form_serial_numbers', {
          form_code : settings.form_code,
          vehicle_id: vehicle.id
        }, 'vehicle_form_serial_number')
        .then(() => window.open(`${ API.url }/reports/jasper_vehicle_forms/${ vehicle.id }/${ settings.form_code }.pdf`, '_blank'));
      }
    }));
  }

  viewBranchHistory ( vehicle : VehicleModel ) : Promise<any> {
    return this.apiService.get('/vehicles/invoice_list', [
      vehicle.id,
      0,
      '*',
      '*',
      '*'
    ])
    .then(( invoices : Array<any> ) => {
      const modal = this.modalService.open(VehicleBranchHistoryComponent, { windowClass: 'x-lg-modal' });
      modal.componentInstance.invoices = invoices;
      modal.componentInstance.vehicle  = vehicle;
      return modal.result;
    });
  }

  viewFollowUpNotes ( vehicle : VehicleModel, reference : string, view : string ) : Promise<any> {
    const modal = this.modalService.open(VehicleFollowUpNotesComponent, { windowClass: 'lg-modal' });
    modal.componentInstance.vehicle   = vehicle;
    modal.componentInstance.reference = reference;
    modal.componentInstance.view      = view;
    return modal.result;
  }
}
